import { render, staticRenderFns } from "./logoutInstanceDialog.vue?vue&type=template&id=06f0f2c0&scoped=true"
import script from "./logoutInstanceDialog.vue?vue&type=script&lang=js"
export * from "./logoutInstanceDialog.vue?vue&type=script&lang=js"
import style0 from "./logoutInstanceDialog.vue?vue&type=style&index=0&id=06f0f2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0f2c0",
  null
  
)

export default component.exports